import React, { useState } from 'react'
import SideBar from '../SideBar.js'
import Header from '../../Header/Header.js'
import BillingHeader from './BillingHeader.js'

const EarlyCODRemittancePlan = () => {

    const [selectedPlan, setSelectedPlan] = useState("T+4 Days (Default)");

    const plans = [
        { title: "T+1 Day", charge: "1.00%", frequency: "All Weekdays", transaction: "The Applicable transaction charges is 1.00% of the COD amount (Exclusive of GST)", defaultPlan: false },
        { title: "T+2 Days", charge: "0.70%", frequency: "All Weekdays", transaction: "The Applicable transaction charges is 0.70% of the COD amount (Exclusive of GST)", defaultPlan: false },
        { title: "T+3 Days", charge: "0.50%", frequency: "All Weekdays", transaction: "The Applicable transaction charges is 0.50% of the COD amount (Exclusive of GST)", defaultPlan: false },
        { title: "T+4 Days (Default)", charge: "0%", frequency: "Weekly Twice", transaction: "The Applicable transaction charges is 0.00% of the COD amount (Exclusive of GST)", defaultPlan: true },
    ];
    return (
        <div>
            {/* Header */}
            <Header />

            <div className="flex min-h-screen bg-slate-100 overflow-hidden">
                {/* Sidebar */}
                <SideBar />
                {/* Main Content */}
                <div className="flex-1 space-y-3 md:p-6 py-6 overflow-x-hidden ml-16">
                    <BillingHeader />

                    <div className="mt-2 bg-white p-6 border rounded-lg">
                        <div className="bg-white">

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center">
                                {/* Left Section - Plan Information */}
                                <div>
                                    <h2 className="text-xl font-bold text-gray-900 mb-3">
                                        Early COD Remittance Plan
                                    </h2>
                                    <p className="text-gray-600">
                                        Choose the best payment plan for your business and optimize cash flow.
                                    </p>
                                </div>

                                {/* Right Section - Current Plan Card */}
                                <div className="p-6 border rounded-xl shadow-md bg-slate-50">
                                    <h3 className="font-semibold mb-6 text-gray-800">Current Plan</h3>
                                    <p className="text-gray-700">
                                        <span className="font-medium text-gray-900">Cycle:</span> {selectedPlan}
                                    </p>
                                    <p className="text-gray-700 text-base mt-2">
                                        <span className="font-medium text-gray-900">Frequency:</span> Weekly Twice
                                    </p>
                                </div>
                            </div>

                            <div className="grid grid-cols-1 mt-6 md:grid-cols-2 lg:grid-cols-4 gap-6">
                                {plans.map((plan, index) => (
                                    <div
                                        key={index}
                                        className={`p-6 border rounded-2xl shadow-lg transition-all ${plan.defaultPlan
                                            ? "bg-slate-50 border-slate-400"
                                            : "bg-white border-gray-200 hover:shadow-xl"
                                            }`}
                                    >
                                        <h3 className="text-xl font-semibold text-gray-800">{plan.title}</h3>
                                        <p className="text-gray-600 text-sm mt-7">
                                            <span className="font-bold">{plan.charge}</span> of COD Amount
                                        </p>
                                        <p className="text-sm text-gray-700 my-7">{plan.transaction}</p>
                                        <p className="text-sm text-gray-700">Remittance: {plan.frequency}</p>

                                        <div className="mt-6 flex items-center">
                                            <input
                                                type="checkbox"
                                                id={`terms-${index}`}
                                                className="mr-2 accent-blue-600"
                                                disabled={plan.defaultPlan}
                                            />
                                            <label
                                                htmlFor={`terms-${index}`}
                                                className="text-blue-600 text-sm cursor-pointer"
                                            >
                                                I agree to the Terms & Conditions
                                            </label>
                                        </div>

                                        <div className="relative group">
                                            <button
                                                className={`mt-5 w-full py-2 rounded-lg text-white font-medium transition-all ${!plan.defaultPlan
                                                    ? "bg-gray-400 cursor-not-allowed"
                                                    : "bg-slate-700 cursor-not-allowed hover:bg-slate-800"
                                                    }`}
                                                disabled={!plan.defaultPlan} // Disabled for non-default plans
                                                onClick={() => setSelectedPlan(plan.title)}
                                            >
                                                Activate
                                            </button>

                                            {/* Tooltip for Disabled Button */}
                                            {!plan.defaultPlan && (
                                                <div className="absolute left-1/2 -top-3 -translate-x-1/2 hidden group-hover:block w-max bg-gray-900 text-white text-xs py-1 px-3 rounded-md shadow-lg">
                                                    Plans are not available for low transaction volumes.
                                                </div>
                                            )}
                                        </div>

                                    </div>
                                ))}
                            </div>


                        </div>
                    </div>
                </div>


            </div>
        </div>

    )
}

export default EarlyCODRemittancePlan
